import { Terminal } from "lucide-react";

const sevColor = {
  critical: "#FF3B30",
  warning: "#FFCC00",
  info: "#71717A",
};

export default function ForensicsPanel({ logs }) {
  if (!logs || logs.length === 0) return null;
  return (
    <div className="bg-card border border-border/60 rounded-md" data-testid="forensics-panel">
      <div className="px-3 py-2 border-b border-border/60 bg-popover flex items-center gap-2">
        <Terminal className="w-3.5 h-3.5 text-status-normal" />
        <span className="label-ot">Forensics &amp; Network Logs</span>
        <span className="font-mono text-[10px] text-muted-foreground ml-auto">{logs.length} entries</span>
      </div>
      <div className="p-2 font-mono text-[11px] max-h-[240px] overflow-y-auto">
        {logs.map((l, i) => (
          <div key={i} data-testid="forensic-log" className="flex gap-2 px-2 py-1 hover:bg-secondary/30 rounded-sm">
            <span className="text-muted-foreground shrink-0">{l.ts}</span>
            <span className="shrink-0 w-24 truncate" style={{ color: sevColor[l.severity] || "#A1A1AA" }}>[{l.source}]</span>
            <span className="text-foreground/85 flex-1">{l.message}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
